var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppUsersIcon = function SvgAppUsersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8224_11216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 28C1.33301 25.3347 3.49301 23.1747 6.15834 23.1747H10.9837C13.649 23.1747 15.809 25.3347 15.809 28",
    stroke: "#8E8E93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5572 12.3475C13.2062 13.9965 13.2062 16.6701 11.5572 18.3192C9.90812 19.9683 7.23448 19.9683 5.58542 18.3192C3.93637 16.6701 3.93637 13.9965 5.58542 12.3475C7.23448 10.6984 9.90812 10.6984 11.5572 12.3475Z",
    stroke: "#8E8E93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1275 18.4107C27.7382 18.4107 30.6662 15.4827 30.6662 11.872C30.6662 8.26134 27.7395 5.33334 24.1275 5.33334C20.5155 5.33334 17.5889 8.26134 17.5889 11.872",
    stroke: "#8E8E93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1348 18.4173C23.1508 18.4173 22.2188 18.2 21.3814 17.812L17.3574 18.6667L18.1988 14.6347C17.8081 13.7947 17.5894 12.8587 17.5894 11.872",
    stroke: "#8E8E93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4834 11.5164C24.6787 11.7117 24.6787 12.0283 24.4834 12.2236C24.2882 12.4188 23.9716 12.4188 23.7763 12.2236C23.5811 12.0283 23.5811 11.7117 23.7763 11.5164C23.9716 11.3212 24.2882 11.3212 24.4834 11.5164Z",
    fill: "#8E8E93",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4834 11.5164C21.6787 11.7117 21.6787 12.0283 21.4834 12.2236C21.2882 12.4188 20.9716 12.4188 20.7763 12.2236C20.5811 12.0283 20.5811 11.7117 20.7763 11.5164C20.9716 11.3212 21.2882 11.3212 21.4834 11.5164Z",
    fill: "#8E8E93",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4834 11.5164C27.6787 11.7117 27.6787 12.0283 27.4834 12.2236C27.2882 12.4188 26.9716 12.4188 26.7763 12.2236C26.5811 12.0283 26.5811 11.7117 26.7763 11.5164C26.9716 11.3212 27.2882 11.3212 27.4834 11.5164Z",
    fill: "#8E8E93",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8224_11216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
export { SvgAppUsersIcon as ReactComponent };
export default __webpack_public_path__ + "app-users-icon.svg";